import moment from 'moment/moment';

export function localToUtcDatetimeFilter(date: string): string {
  if (!date) return '';
  return moment(date).utc().format('YYYY-MM-DD HH:mm:ss');
}
